import { render, staticRenderFns } from "./Restablecer3.vue?vue&type=template&id=9e0236ae&scoped=true&"
import script from "./Restablecer3.vue?vue&type=script&lang=js&"
export * from "./Restablecer3.vue?vue&type=script&lang=js&"
import style0 from "./Restablecer3.vue?vue&type=style&index=0&id=9e0236ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0236ae",
  null
  
)

export default component.exports